<template>
  <QToolbar class="etab-desktop-header bg-secondary text-white">
    <img
      style="cursor: pointer; margin-right: 25px"
      :src="require('@core/assets/img/logo_extracadabra_full.png')"
      alt="logo"
      @click="goToSmartHome"
    />

    <template v-if="userIsAuthenticated && !isMasterEtabWithoutSupervisedEtab">
      <QBtn
        icon="icon-f-layers"
        no-caps
        flat
        dense
        stack
        :class="{ 'btn-route-active': isActive(ROUTE_DASHBOARD) }"
        :to="{ name: ETAB_ROUTES.dashboard.tabs.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@RECRUITMENTS')"
      />

      <QBtn
        icon="icon-f-plus-circle"
        no-caps
        flat
        dense
        stack
        :class="{ 'btn-route-active': isActive(ROUTE_CREATION) }"
        :to="{ name: ETAB_ROUTES.creation.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@SEARCH')"
      />

      <QBtn
        v-if="isMasterEtabWithSupervisedEtab"
        icon="icon-extra-multi-etab"
        no-caps
        flat
        dense
        stack
        :class="{ 'btn-route-active': isActive(ROUTE_MULTI_ACCOUNT) }"
        :to="{ name: ETAB_ROUTES.account.multiAccount.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ETABLISSEMENTS')"
      />

      <QSpace />

      <QBtn
        icon="icon-f-user"
        no-caps
        flat
        dense
        stack
        :class="{ 'btn-route-active': isActive([ROUTE_USER_MENU, ROUTE_PAYMENT, ROUTE_ACCOUNT]) }"
        :to="{ name: ETAB_ROUTES.userMenu.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ACCOUNT')"
      />
    </template>
    <template v-if="userIsAuthenticated && isMasterEtabWithoutSupervisedEtab">
      <QBtn
        icon="icon-extra-multi-etab"
        no-caps
        flat
        dense
        stack
        :class="{ 'btn-route-active': isActive(ROUTE_MULTI_ACCOUNT) }"
        :to="{ name: ETAB_ROUTES.account.multiAccount.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ETABLISSEMENTS')"
      />

      <QSpace />

      <QBtn
        icon="icon-f-user"
        no-caps
        flat
        dense
        stack
        :class="{ 'btn-route-active': isActive(ROUTE_USER_MENU) }"
        :to="{ name: ETAB_ROUTES.userMenu.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ACCOUNT')"
      />
    </template>
  </QToolbar>
</template>

<script>
  import { ETAB_ROUTES, ROUTE_DASHBOARD, ROUTE_USER_MENU, ROUTE_PAYMENT, ROUTE_ACCOUNT, ROUTE_CREATION, ROUTE_MULTI_ACCOUNT } from "@etab/config";
  import { AuthenticationManager } from "@core/managers/authentication.manager";
  import { UserStorageManager } from "@core/managers/user-storage.manager";
  import { CORE_EVENTS, ROLE } from "@core/constants";
  import { EventManager } from "@core/managers/event.manager";

  export default {
    data() {
      return {
        userIsAuthenticated: false,
        hasSupervisedEtab: undefined,
        masterEtab: false,
      };
    },
    computed: {
      isMasterEtabWithoutSupervisedEtab() {
        return this.masterEtab && !this.hasSupervisedEtab;
      },
      isMasterEtabWithSupervisedEtab() {
        return this.masterEtab && this.hasSupervisedEtab;
      },
    },
    created() {
      this.ETAB_ROUTES = ETAB_ROUTES;
      this.ROUTE_DASHBOARD = ROUTE_DASHBOARD;
      this.ROUTE_USER_MENU = ROUTE_USER_MENU;
      this.ROUTE_PAYMENT = ROUTE_PAYMENT;
      this.ROUTE_ACCOUNT = ROUTE_ACCOUNT;
      this.ROUTE_CREATION = ROUTE_CREATION;
      this.ROUTE_MULTI_ACCOUNT = ROUTE_MULTI_ACCOUNT;
      this.events = [
        { name: CORE_EVENTS.ON_LOGIN, action: this.checkAuth },
        { name: CORE_EVENTS.ON_LOGOUT, action: this.checkAuth },
        { name: CORE_EVENTS.ON_LOGIN, action: this.isMasterEtab },
      ];

      this.registerEvents();
      this.isMasterEtab();
      this.hasCurrentSupervisedEtab();
      this.checkAuth();
    },
    beforeUnmount() {
      this.unregisterEvents();
    },
    methods: {
      registerEvents() {
        EventManager.registerAllEvents(this.events);
      },
      unregisterEvents() {
        EventManager.unregisterAllEvents(this.events);
      },
      async checkAuth() {
        this.userIsAuthenticated = await AuthenticationManager.isUserAuthenticated();
      },
      isActive(routeSegment) {
        const routeAncestors = this.$route.matched;
        return routeAncestors.some((ancestor) => {
          return routeSegment.includes(ancestor.name);
        });
      },
      goToSmartHome() {
        if (this.isMasterEtabWithoutSupervisedEtab) {
          this.$router.push({ name: ETAB_ROUTES.account.multiAccount.name }).catch((suppressedError) => {});
        } else {
          this.$router.push({ name: ETAB_ROUTES.smartRedirect.name }).catch((suppressedError) => {});
        }
      },
      async hasCurrentSupervisedEtab() {
        this.hasSupervisedEtab = !!(await UserStorageManager.getSupervisorData());
      },
      async isMasterEtab() {
        const user = await UserStorageManager.getUser();
        if (user) {
          const role = user.role[0];
          if (role === ROLE.MASTER) {
            this.masterEtab = true;
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  .etab-desktop-header {
    .q-btn {
      height: 50px;
      padding: 0 16px;
      border-radius: 0;
    }
  }
</style>
